import { render, staticRenderFns } from "./assignedEmployeesListItem.vue?vue&type=template&id=c4571d62"
import script from "./assignedEmployeesListItem.vue?vue&type=script&lang=ts"
export * from "./assignedEmployeesListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports